import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)

Vue.config.productionTip = false

Vue.prototype.publicPath = '';
Vue.prototype.apiPath = 'https://portal.winfinbd.com/api/';
Vue.prototype.basePath = 'https://winfinbd.com';
Vue.prototype.loginUrl = 'https://portal.winfinbd.com/';

Vue.use(VueAxios, axios)

import Toaster from 'v-toaster'

// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'v-toaster/dist/v-toaster.css'

// optional set default timeout, the default is 10000 (10 seconds).
Vue.use(Toaster, {timeout: 5000})

export const bus = new Vue();


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
